const STEPS = [
  {
    title: "Book a consultation",
    copy: "Tell us a little about your goals and we'll get you on the schedule at the location that works best.",
  },
  {
    title: "Meet Dr. Amy",
    copy: "We'll review your smile, discuss treatment options, and answer every question — no pressure, no jargon.",
  },
  {
    title: "Build your plan",
    copy: "Our financial team will walk through insurance, financing, and flexible payment options designed around you.",
  },
  {
    title: "Start smiling",
    copy: "From your first appointment to retainer day, we'll be right there with you — celebrating every milestone.",
  },
];

const POLICIES = [
  {
    title: "Insurance & financing",
    copy: "We accept most major insurances and will help you verify and apply your benefits. Flexible payment plans make orthodontics surprisingly affordable.",
  },
  {
    title: "Cancellation policy",
    copy: "Please give us at least 48 hours notice if you need to reschedule. Appointments cancelled within 24 hours may be subject to a cancellation charge.",
  },
  {
    title: "Orthodontic emergencies",
    copy: "If you're experiencing discomfort, a loose bracket, or a poking wire, give your office a call right away — we'll get you taken care of.",
  },
];

export default function PatientInfo() {
  return (
    <section id="patient-info" className="bg-cream-50">
      <div className="section">
        <div className="grid gap-14 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <p className="eyebrow">Your journey</p>
            <h2 className="mt-4 text-3xl sm:text-4xl">
              What to expect — from hello to your final retainer.
            </h2>
            <p className="mt-5 text-sage-700/90">
              We've simplified the path to a confident smile so you can focus
              on what matters: enjoying the journey.
            </p>
          </div>

          <ol className="space-y-5 lg:col-span-7">
            {STEPS.map((step, idx) => (
              <li
                key={step.title}
                className="flex gap-5 rounded-2xl border border-sage-100 bg-cream-100/60 p-6"
              >
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-sage-700 font-serif text-base text-cream-50">
                  {idx + 1}
                </span>
                <div>
                  <h3 className="font-serif text-lg text-sage-800">
                    {step.title}
                  </h3>
                  <p className="mt-1 text-sm leading-relaxed text-sage-700/90">
                    {step.copy}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </div>

        <div className="mt-20 grid gap-6 sm:grid-cols-3">
          {POLICIES.map((policy) => (
            <div
              key={policy.title}
              className="rounded-2xl border border-blush-100 bg-blush-50/60 p-6"
            >
              <h3 className="font-serif text-lg text-sage-800">
                {policy.title}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-sage-700/90">
                {policy.copy}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
